export default "__VITE_ASSET__a9298943__"